export default __webpack_public_path__ + "static/media/logo-protected.7c1c8b13.png";